export const SET_ROLES = 'Roles/set';

export const SET_PERMESSIONS = 'Permissions/set';
